<template>
  <div class="yt-login-wrapper">
    <div class="yt-login-container">
      <div class="yt-login-left">
        <h3>应工程安全监测之需 为监测工程安全传感</h3>
        <!--
        <div class="yt-login-left__imgs">
          <img
            :class="`img_${index+1}`"
            :key="index"
            :src="img"
            alt="imgOne"
            v-for="(img, index) in imgs"
          />
        </div>
        -->
        <div class="yt-login-left-ong">
          <img
            class="yt-login-left-ong-img"
            :src="imgOne"
            alt="imgOne"
          />
        </div>
      </div>
      <div
        :style="rightStyle"
        class="yt-login-right"
      >
        <div class="yt-login-form">
          <div class="yt-login-form__title">账号密码登录</div>
          <a-form
            :form="form"
            ref="form"
          >
            <a-form-item>
              <a-input
                placeholder="请输入账号名"
                v-decorator="['username', {rules: [{ required: true, message: '请输入帐户名或邮箱' }, { validator: this.handleUsernameOrEmail }], validateTrigger: 'change'}]"
              >
                <a-icon
                  :style="{ color: '#53C1EF' }"
                  slot="prefix"
                  type="user"
                />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input-password
                placeholder="密码"
                v-decorator="['password', {rules: [{ required: true, message: '请输入密码' }],validateTrigger: 'blur'}]"
              >
                <a-icon
                  :style="{ color: '#53C1EF' }"
                  slot="prefix"
                  type="lock"
                />
              </a-input-password>
            </a-form-item>
          </a-form>
          <div class="yt-login-form__tools">
            <a-checkbox v-model="rememberMe">自动登录</a-checkbox>
            <a href="http://39.104.49.50:81/">大屏展示入口</a>
          </div>
          <a-button
            :loading="isLoading"
            @click="handleSubmit"
            block
            class="yt-login-form__submit"
          >确认</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/login/logo.png'
import Vue from 'vue'
import { mapActions } from "vuex"
import { getAction } from '@/api/manage'
// 批量请求图片
const getImgs = async function() {
  const result = []
  for (let i = 1; i <= 7; i++) {
    const res = await import(`@/assets/login/${i}.png`)
    result.push(res.default)
  }
  return result
}
import { ACCESS_TOKEN } from "@/store/mutation-types"
import { timeFix } from "@/utils/util"
export default {
  data () {
    return {
      imgs: [],
      imgOne: '/default/left.png',
      rightStyle: {
        backgroundImage: `url(${logo})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center 32px',
        backgroundSize: '254px 60px'
      },
      isLoading: false,
      form: this.$form.createForm(this, { username: '', password: '' }),
      rememberMe: true
    }
  },
  mounted () {
  },
  async created() {
    //this.imgs = await getImgs()
    Vue.ls.remove(ACCESS_TOKEN);
    //个性化首页和logo标识
    if(myPersonalizationSetData == null){
      let wPath = window.location.href;
      getAction("/show/personalization/queryByPath", {'path':wPath}).then((res) => {
        if (res.success) {
          //console.log(res.result);
          if(res.result){
            myPersonalizationSetData = res.result;
          }else{
            myPersonalizationSetData = defaultPersonalizationSetData;
          }
        }else{
          myPersonalizationSetData = defaultPersonalizationSetData;
        }
        this.rightStyle.backgroundImage = 'url(' + myPersonalizationSetData.logoUrl + ')';
        this.imgOne = myPersonalizationSetData.leftBg;
      });
    }else{
      this.rightStyle.backgroundImage = 'url(' + myPersonalizationSetData.logoUrl + ')';
      this.imgOne = myPersonalizationSetData.leftBg;
    }

  },
  methods: {
    ...mapActions(["Login", "Logout"]),
    // 校验用户名
    handleUsernameOrEmail (rule, value, callback) {
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
      if (regex.test(value)) {
        this.loginType = 0
      } else {
        this.loginType = 1
      }
      callback()
    },
    // 登录触发事件
    handleSubmit () {
      let flag = false
      let loginParams = {
        remember_me: this.rememberMe
      }
      // 表单校验
      this.form.validateFields(['username', 'password'], { force: true }, (err, values) => {
          if (!err) {
            flag = true
            loginParams = {...loginParams, ...values}
          }
      })
      if (!flag) return

      this.isLoading = true
      this.Login(loginParams).then(() => {
        console.log("login");
        this.loginSuccess()
      }).catch((err) => {
        this.requestFailed(err);
      })
    },
    // 登录成功跳转
    loginSuccess () {
      this.isLoading = false
      this.$router.push({ name: "dashboard" })
      this.$notification.success({
        message: '欢迎',
        description: `${timeFix()}，欢迎回来`,
      });
    },
    // 登录失败跳转
    requestFailed (err) {
      this.$notification['error']({
        message: '登录失败',
        description: ((err.response || {}).data || {}).message || err.message || "请求出现错误，请稍后再试",
        duration: 4,
      });
      this.isLoading = false;
    }
  }
}
</script>

<style lang='less' scoped>
.yt-login-container {
  width: 900px;
  height: 420px;
  position: absolute;
  right: 32px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  .yt-login-left,
  .yt-login-right {
    float: left;
    width: 50%;
    height: 100%;
  }
  .yt-login-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(to top, rgba(255, 255, 255, 0.7), #b3d0e6);
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    margin: 0 auto;
    & h3 {
      font-size: 18px;
      font-weight: 500;
      margin-top: 60px;
    }
    & yt-login-left-ong{
      width: 325px;
      height: 240px;
      .yt-login-left-ong-img{
        width: 325px;
        height: 240px;
      }
    }
    & .yt-login-left__imgs {
      display: grid;
      grid-template-columns: 115px 80px 115px;
      grid-template-rows: 80px 80px 170px;
      grid-gap: 5px 5px;
      width: 325px;
      height: 240px;
      img {
        object-fit: cover;
      }
      .img_1,
      .img_3,
      .img_4,
      .img_6 {
        width: 115px;
        height: 80px;
      }
      .img_2 {
        width: 80px;
        height: 165px;
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 1;
        grid-row-end: 3;
      }
      .img_7 {
        width: 80px;
        height: 80px;
      }
      .img_5 {
        width: 115px;
        height: 170px;
      }
    }
  }
  .yt-login-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #09a3e9;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    .yt-login-form {
      width: 254px;
      margin-top: 120px;
      .yt-login-form__title {
        font-size: 16px;
        line-height: 1;
        padding: 10px 0;
        text-align: center;
        background-color: #ffffff;
        border-radius: 4px;
      }
      .yt-login-form__tools {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        a {
          color: #333333;
        }
      }
      .yt-login-form__submit {
        margin-top: 24px;
        letter-spacing: 4px;
      }
      /deep/ .ant-input-affix-wrapper {
        margin-top: 24px;
        .ant-input {
          border-color: transparent;
          border-bottom-color: rgba(255, 255, 255, 0.8);
          border-radius: 0;
          &::-webkit-input-placeholder {
            color: #53c1ef;
          }
          &::-moz-placeholder {
            color: #53c1ef;
          }
          &:-moz-placeholder {
            color: #53c1ef;
          }
          &::-ms-input-placeholder {
            color: #53c1ef;
          }
        }
      }
      /deep/ .ant-input-password-icon {
        color: #53c1ef;
      }
    }
  }
}
</style>
